export const formatDate = (dateStr: string): string => {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateToQuarter = (dateStr: string): string => {
  const date = new Date(dateStr);
  const quarter = Math.floor(date.getUTCMonth() / 3) + 1;
  return `Q${quarter} ${date.getUTCFullYear()}`;
};

export const timeSince = (timestamp: string): string => {
  const HOUR_SECONDS = 60 * 60;
  const DAY_SECONDS = HOUR_SECONDS * 24;
  const MONTH_SECONDS = DAY_SECONDS * 30;
  const YEAR_SECONDS = DAY_SECONDS * 365;

  const date: any = new Date(timestamp);
  const now: any = new Date();
  const seconds = Math.floor((now - date) / 1000);

  if (seconds <= 0) {
    return 'now';
  }

  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(seconds / HOUR_SECONDS);
  const days = Math.floor(seconds / DAY_SECONDS);
  const months = Math.floor(seconds / MONTH_SECONDS);
  const years = Math.floor(seconds / YEAR_SECONDS);

  let result;
  if (years) {
    result = `${years} year${years === 1 ? '' : 's'} ago`;
  } else if (months) {
    result = `${months} month${months === 1 ? '' : 's'} ago`;
  } else if (days) {
    result = `${days} day${days === 1 ? '' : 's'} ago`;
  } else if (hours) {
    result = `${hours} hour${hours === 1 ? '' : 's'} ago`;
  } else if (minutes) {
    result = `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  } else if (seconds > 0) {
    result = `${seconds} second${seconds === 1 ? '' : 's'} ago`;
  } else {
    result = 'now';
  }

  return result;
};
export {cn} from '@repo/ui/lib/utils';
